module.exports = "<svg width=\"24\" height=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.5 12.064L7 6v12.13z\" fill-rule=\"evenodd\"></path></svg>"